import { apiFetch } from "./client";
import Expense from "../dto/Expense";

async function parseError(response) {
    try {
        const json = await response.json();

        return (
            json.error ||
            json.errors?.join(", ") ||
            `Request failed with status ${response.status}`
        );
    } catch {
        return `Request failed with status ${response.status}`;
    }
}

export async function createExpense({ title, matchers }) {
    const response = await apiFetch("/api/expenses", {
        method: "POST",
        body: JSON.stringify({
            expense: {
                title,
                expense_matchers_attributes: matchers.map((matcher) => ({
                    title: matcher.title,
                })),
            },
        }),
    });

    if (!response.ok) {
        throw new Error(await parseError(response));
    }

    const json = await response.json();

    return new Expense(json.expense);
}

export async function fetchExpenses() {
    const response = await apiFetch("/api/expenses");

    if (!response.ok) {
        throw new Error(await parseError(response));
    }

    const json = await response.json();

    return json.expenses.map((expense) => new Expense(expense));
}

export async function updateExpense({ id, title, matchers }) {
    const expense = {};

    if (title !== undefined) {
        expense.title = title;
    }

    if (matchers !== undefined) {
        expense.expense_matchers_attributes = matchers.map((matcher) => {
            const matcherAttributes = {
                title: matcher.title || "",
            };

            if (matcher.id !== undefined) {
                matcherAttributes.id = matcher.id;
            }

            if (matcher.destroy === true) {
                matcherAttributes._destroy = true;
            }

            return matcherAttributes;
        });
    }

    const response = await apiFetch(`/api/expenses/${id}`, {
        method: "PATCH",
        body: JSON.stringify({
            expense,
        }),
    });

    if (!response.ok) {
        throw new Error(await parseError(response));
    }

    const json = await response.json();

    return new Expense(json.expense);
}

export async function deleteExpense(id) {
    const response = await apiFetch(`/api/expenses/${id}`, {
        method: "DELETE",
    });

    if (!response.ok) {
        throw new Error(await parseError(response));
    }
}
